import React from 'react';

import { Badge, Button, Typography } from '@rbilabs/universal-components';
import { GestureResponderEvent, StyleSheet, View } from 'react-native';

import { OfferFeedbackMessage } from 'pages/cart/cart-item/styled';
import { t } from 'state/intl/translations';
import { getDesignToken } from 'styles/constants';

import type { OfferListItemProps } from '../types';

import { OfferBadges, OfferBadgesProps } from './offer-badges';

type OfferContentProps = Pick<OfferListItemProps, 'header' | 'description'> &
  OfferBadgesProps & {
    isHovered: boolean;
    expiresAt?: string | null;
    configOfferDateRange?: string;
    isGroup?: boolean;
    isPartnershipOffer?: boolean;
    activateButtonLabel?: string;
    onPartnershipActivate?: ((event: GestureResponderEvent) => void) | null | undefined;
    linkedButtonLabel?: string;
    isWalmartUser?: boolean;
  };

export const OfferContent = ({
  header,
  description,
  isHovered,
  expiresAt,
  configOfferDateRange,
  isGroup,
  isPartnershipOffer,
  activateButtonLabel,
  onPartnershipActivate,
  linkedButtonLabel,
  isWalmartUser,
  ...badgesProps
}: OfferContentProps) => {
  return (
    <View style={styles.textContainer}>
      <Typography
        variant="headerThree"
        color={isHovered ? getDesignToken('text-active') : getDesignToken('text-default')}
        ellipsizeMode="tail"
        numberOfLines={2}
        accessibilityLevel={2}
        style={{
          marginBottom: 1,
        }}
      >
        {header}
      </Typography>
      {description}
      {expiresAt ? <OfferFeedbackMessage>{expiresAt}</OfferFeedbackMessage> : null}
      {configOfferDateRange ? (
        <OfferFeedbackMessage>{configOfferDateRange}</OfferFeedbackMessage>
      ) : null}

      {isPartnershipOffer && !isWalmartUser && (
        <Button
          size="sm"
          mt="$2"
          mb="$2"
          pb="$1"
          pt="$1"
          onPress={onPartnershipActivate}
          variant="outline"
        >
          {activateButtonLabel}
        </Button>
      )}

      {isPartnershipOffer && isWalmartUser && (
        <Badge mt="$2" variant="default-subtle" backgroundColor="#D1FAE5" iconName="checkFill">
          {linkedButtonLabel || 'Active'}
        </Badge>
      )}

      {isGroup && (
        <Badge variant="default-solid" iconName="offer" mt="$2" mr="$2">
          {t('offerGroupBadgeLabel')}
        </Badge>
      )}

      <OfferBadges {...badgesProps} />
    </View>
  );
};

const styles = StyleSheet.create({
  textContainer: {
    flexShrink: 1,
    marginLeft: 12, // $3
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: 8, // space={2} equivalent
  },
});
